/* eslint-disable max-len */

import React from 'react';
import styled from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';
import { SalesMen } from '../icons';

const Title = styled.h2`
  font-size: 2rem;
  margin-bottom: 30px;
  text-align: center;
  text-transform: uppercase;
`;

const ReviewsWrapper = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: ${(props) => props.theme.grid.gap};
  overflow-y: scroll;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    overflow-y: visible;
  }
`;

const Review = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
  box-shadow: 0px 0px 12px 1px rgba(0,0,0,0.28);
  border-radius: ${(props) => props.theme.borderRadius};
  min-width: 280px;
  margin: ${(props) => props.theme.grid.gap} 0;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    margin: 0;
    min-width: auto;
  }
  &:first-child {
    margin-left: ${(props) => props.theme.grid.gap};
  }
  p {
    line-height: 160%;
  }
  .reviewer {
    display: flex;
    svg {
      width: 30px;
      height: 30px;
      margin-right: 10px;
      color: ${(props) => props.theme.gray2};
    }
    h3 {
      margin: 0;
      font-size: 1rem;
      color: ${(props) => props.theme.primaryColor};
    }

    h4 {
      margin: 0;
      font-size: 1rem;
      font-weight: 400;
      color: ${(props) => props.theme.gray3};
    }
  }
`;

const SeminarReviews = () => (
  <Container>
    <Title>Ervaringen van onze deelnemers</Title>
    <ReviewsWrapper>
      <Review>
        <p>
          “Dit was een zeer inspirerende seminar met de focus op &apos;Online Leads&apos;. Mensen gingen vroeger langs alle (auto)showrooms om inspiratie op te doen. Tegenwoordig doet men dit via het internet.”
        </p>
        <div className="reviewer">
          <SalesMen />
          <div>
            <h3>Amir Kharbouch</h3>
            <h4>Maas autogroep</h4>
          </div>
        </div>
      </Review>
      <Review>
        <p>
          “Paul heeft een hele inspirerende seminar gegeven. Ik ga zijn adviezen zeker gebruiken!”
        </p>
        <div className="reviewer">
          <SalesMen />
          <div>
            <h3>Vinny Donck</h3>
            <h4>Motorhuis</h4>
          </div>
        </div>
      </Review>
      <Review>
        <p>
          “Afgelopen dinsdag heb ik een enorm interessante seminar van Paul de Vries mogen bijwonen. Hij heeft me in korte tijd veel duidelijk op het gebied van online verkoop. Een echte &quot;Eye-opener&quot;”
        </p>
        <div className="reviewer">
          <SalesMen />
          <div>
            <h3>Rienk Elzinga</h3>
            <h4>ABD Renault</h4>
          </div>
        </div>
      </Review>
      <Review>
        <p>
          “Afgelopen dinsdag een Seminar van Paul bijgewoond. Niet wetende wat ik echt kon verwachten ging ik er dus blanco in. Paul heeft me verrast, niet alleen met een geweldig sterk verhaal maar ook door de spiegel die hij voorhield.”
        </p>
        <div className="reviewer">
          <SalesMen />
          <div>
            <h3>Koen Koperberg</h3>
            <h4>Kien</h4>
          </div>
        </div>
      </Review>
    </ReviewsWrapper>
  </Container>
);

export default SeminarReviews;
